import React, { useEffect, useState } from 'react';
import { req } from '../services/api';

export default function Settings() {
  const [config, setConfig] = useState(null);
  const [loading, setLoading] = useState(true);
  const [changing, setChanging] = useState(false);

  useEffect(() => {
    loadSettings();
  }, []);

  const loadSettings = async () => {
    setLoading(true);

    try {
      const data = await req('GET', '/stripe-config');

      if (data) {
        setConfig({
          mode: data.mode || 'test',
          environment: data.environment || 'unknown',
          liveAllowed: data.liveAllowed === true
        });
      }
    } catch (error) {
      alert(
        'Chyba p\u0159i na\u010d\u00edt\u00e1n\u00ed nastaven\u00ed: ' +
          (error?.message || 'nezn\u00e1m\u00e1 chyba')
      );
    } finally {
      setLoading(false);
    }
  };

  const setStripeMode = async mode => {
    if (!config || changing) return;

    if (mode === config.mode) {
      return;
    }

    if (mode === 'live') {
      if (!config.liveAllowed) {
        alert(
          'LIVE platby jsou v tomto prostředí zakázané.'
        );
        return;
      }

      const typed = window.prompt(
        'POZOR: Zapnutím LIVE režimu budou zákazníci platit skutečnými penězi.\n\nPro potvrzení napište přesně:\nENABLE LIVE PAYMENTS'
      );

      if (typed !== 'ENABLE LIVE PAYMENTS') {
        alert('LIVE režim nebyl aktivován.');
        return;
      }

      if (
        !window.confirm(
          'Poslední potvrzení: opravdu chcete zapnout ostré Stripe platby?'
        )
      ) {
        return;
      }
    } else {
      if (
        !window.confirm(
          'Opravdu chcete přepnout Stripe do TEST režimu?'
        )
      ) {
        return;
      }
    }

    setChanging(true);

    try {
      const body =
        mode === 'live'
          ? {
              mode: 'live',
              confirmation:
                'ENABLE_LIVE_PAYMENTS'
            }
          : {
              mode: 'test'
            };

      const result = await req(
        'POST',
        '/stripe-config',
        body
      );

      if (!result?.success) {
        alert(
          'Změna se nepodařila: ' +
            (result?.error || 'neznámá chyba')
        );
        return;
      }

      await loadSettings();

      alert(
        '✓ Stripe režim byl změněn na ' +
          mode.toUpperCase()
      );
    } catch (error) {
      alert(
        'Zm\u011bna se nepoda\u0159ila: ' +
          (error?.message || 'nezn\u00e1m\u00e1 chyba')
      );
    } finally {
      setChanging(false);
    }
  };

  if (loading) {
    return (
      <div>
        <div className="page-title">
          Nastavení
        </div>

        <div className="loading-cell">
          Načítám nastavení...
        </div>
      </div>
    );
  }

  const environmentLabel =
    config?.environment === 'production'
      ? 'PRODUCTION'
      : config?.environment === 'staging'
        ? 'STAGING'
        : String(
            config?.environment || 'UNKNOWN'
          ).toUpperCase();

  return (
    <div>
      <div className="page-title">
        Nastavení
      </div>

      <div className="page-sub">
        Systémové a platební nastavení EURO.TAXI
      </div>

      <div className="stats-grid">
        <div className="stat-card">
          <div className="stat-value">
            {environmentLabel}
          </div>

          <div className="stat-label">
            Prostředí serveru
          </div>
        </div>

        <div
          className={
            config?.mode === 'live'
              ? 'stat-card alert'
              : 'stat-card'
          }
        >
          <div className="stat-value">
            {String(
              config?.mode || 'test'
            ).toUpperCase()}
          </div>

          <div className="stat-label">
            Stripe režim
          </div>
        </div>

        <div className="stat-card">
          <div className="stat-value">
            {config?.liveAllowed
              ? 'ANO'
              : 'NE'}
          </div>

          <div className="stat-label">
            LIVE platby povoleny
          </div>
        </div>
      </div>

      <div className="card">
        <div className="card-header">
          <span className="card-title">
            Stripe platby
          </span>

          {config?.mode === 'live' ? (
            <span className="badge badge-red">
              LIVE – skutečné platby
            </span>
          ) : (
            <span className="badge badge-gold">
              TEST – testovací platby
            </span>
          )}
        </div>

        <div style={{ padding: 20 }}>
          <div className="payout-detail-box">
            <div className="payout-row">
              <span className="payout-row-label">
                Prostředí
              </span>

              <span className="payout-row-value">
                {environmentLabel}
              </span>
            </div>

            <div className="payout-row">
              <span className="payout-row-label">
                Aktuální Stripe režim
              </span>

              <span className="payout-row-value">
                {config?.mode === 'live'
                  ? 'LIVE – ostré platby'
                  : 'TEST – testovací platby'}
              </span>
            </div>

            <div className="payout-row">
              <span className="payout-row-label">
                LIVE režim v tomto prostředí
              </span>

              <span className="payout-row-value">
                {config?.liveAllowed
                  ? 'Povolen'
                  : 'Zakázán backendem'}
              </span>
            </div>
          </div>

          {config?.environment ===
            'staging' && (
            <div className="warning-box">
              Toto je STAGING prostředí. LIVE Stripe platby jsou zde z bezpečnostních důvodů zakázané i na backendu.
            </div>
          )}

          {config?.mode === 'live' && (
            <div className="warning-box">
              POZOR: Systém je aktuálně v LIVE režimu. Zákazníci používají skutečné platby.
            </div>
          )}

          <div
            className="actions"
            style={{ marginTop: 20 }}
          >
            <button
              className="btn-sm btn-gold"
              disabled={
                changing ||
                config?.mode === 'test'
              }
              style={{
                padding: '12px 20px',
                opacity:
                  changing ||
                  config?.mode === 'test'
                    ? 0.45
                    : 1
              }}
              onClick={() =>
                setStripeMode('test')
              }
            >
              Přepnout na TEST
            </button>

            <button
              className="btn-sm btn-green"
              disabled={
                changing ||
                !config?.liveAllowed ||
                config?.mode === 'live'
              }
              style={{
                padding: '12px 20px',
                opacity:
                  changing ||
                  !config?.liveAllowed ||
                  config?.mode === 'live'
                    ? 0.45
                    : 1
              }}
              onClick={() =>
                setStripeMode('live')
              }
            >
              Přepnout na LIVE
            </button>
          </div>
        </div>
      </div>

      <div className="card">
        <div className="card-header">
          <span className="card-title">
            Bezpečnost plateb
          </span>
        </div>

        <div style={{ padding: 20 }}>
          <p
            style={{
              color: 'var(--gray)',
              lineHeight: 1.7,
              margin: 0
            }}
          >
            LIVE režim lze zapnout pouze na produkčním serveru.
            Aktivace vyžaduje dvojité potvrzení v administraci
            a speciální potvrzovací hodnotu, kterou kontroluje i backend.
            Na stagingu je LIVE režim blokován bez ohledu na stav tlačítka
            v administraci.
          </p>
        </div>
      </div>
    </div>
  );
}
